<script>
export default {
    name: 'columngroup',
    props: {
        type: {
            type: String,
            default: null
        }
    },
    render() {
        return null;
    }
}
</script>